/**
 * Component: Product tabs
 * Danish Modern L.A. Shopify Theme
 *
 * WAI-ARIA tabs with a vertical tab list: click or arrow keys to switch,
 * Home / End to jump. Panels are shown by CSS until this script defines the
 * element, so the content is never locked away if the script fails.
 */

if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });
    }

    select(tab, focus = false) {
      this.tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute('aria-selected', String(selected));
        t.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
      if (focus) tab.focus();
    }

    onKeydown(event) {
      const index = this.tabs.indexOf(event.currentTarget);
      const last = this.tabs.length - 1;
      const targets = {
        ArrowDown: index === last ? 0 : index + 1,
        ArrowRight: index === last ? 0 : index + 1,
        ArrowUp: index === 0 ? last : index - 1,
        ArrowLeft: index === 0 ? last : index - 1,
        Home: 0,
        End: last,
      };
      if (!(event.key in targets)) return;
      event.preventDefault();
      this.select(this.tabs[targets[event.key]], true);
    }
  }

  customElements.define('product-tabs', ProductTabs);
}
